import { type ReactNode, type Ref } from "react";

import { cn } from "../../utils/cn.util";
import { Tooltip, type TooltipContentProps, type TooltipRootProps } from "./Tooltip";

export interface BasicTooltipProps
  extends TooltipRootProps,
    Pick<TooltipContentProps, "side" | "align" | "sideOffset" | "alignOffset" | "theme"> {
  children: ReactNode;
  content: ReactNode;
  className?: string;
  tooltipClassName?: string;
  showWhenOverflow?: boolean;
  asChild?: boolean;
  disabled?: boolean;
  hideArrow?: boolean;
  ref?: Ref<BasicTooltipProps>;
}

export const BasicTooltip = ({
  ref: _ref,
  children,
  content,
  theme,
  side = "right",
  align = "center",
  className,
  tooltipClassName,
  showWhenOverflow = false,
  sideOffset = 5,
  alignOffset = 0,
  disabled = false,
  asChild = false,
  hideArrow = false,
  defaultOpen,
  open,
}: BasicTooltipProps) => {
  return (
    <Tooltip.Root defaultOpen={defaultOpen} open={open}>
      <Tooltip.Trigger className={className} onOverflow={showWhenOverflow} asChild={asChild} disabled={disabled}>
        {children}
      </Tooltip.Trigger>
      <Tooltip.Content
        sideOffset={sideOffset}
        alignOffset={alignOffset}
        theme={theme}
        side={side}
        align={align}
        className={cn(Boolean(content) && "max-w-[350px] break-words", disabled && "hidden", tooltipClassName)}
      >
        {typeof content === "string" ? <p>{content}</p> : content}
        {!hideArrow ? <Tooltip.Arrow theme={theme} /> : null}
      </Tooltip.Content>
    </Tooltip.Root>
  );
};

BasicTooltip.displayName = "BasicTooltip";
